import { useState } from "react";
import {
    confirmPasswordValidatorr,
    newpasswordValidation,
    oldpasswordValidation
} from "../../../components/validation/Validation";

const touchErrors = (errors) => {
  return Object.entries(errors).reduce((acc, [field, fieldError]) => {
    acc[field] = {
      ...fieldError,
      dirty: true,
    };
    return acc;
  }, {});
};
export const UseChangepasswordformvalidation = (form) => {
  const [errors, setErrors] = useState({
    oldPassword: {
      dirty: false,
      error: false,
      message: "",
    },
    newPassword: {
      dirty: false,
      error: false,
      message: "",
    },
    confirmPassword: {
      dirty: false,
      error: false,
      message: "",
    },
  });

  const validateForm = ({ form, field, errors, forceTouchErrors = false }) => {
    let isValid = true;

    // Create a deep copy of the errors
    let nextErrors = JSON.parse(JSON.stringify(errors));

    // Force validate all the fields
    if (forceTouchErrors) {
      nextErrors = touchErrors(errors);
    }

    const {
    oldPassword,
    newPassword,
    confirmPassword,
    } = form;


    if (nextErrors.oldPassword.dirty && (field ? field === "oldPassword" : true)) {
        const passwordMessage = oldpasswordValidation(oldPassword, form);
        nextErrors.oldPassword.error = !!passwordMessage;
        nextErrors.oldPassword.message = passwordMessage;
        if (!!passwordMessage) isValid = false;
      }
  
  
    if (nextErrors.newPassword.dirty && (field ? field === "newPassword" : true)) {
      const passwordMessage = newpasswordValidation(newPassword, form);
      nextErrors.newPassword.error = !!passwordMessage;
      nextErrors.newPassword.message = passwordMessage;
      if (!!passwordMessage) isValid = false;
    }


    if (
      nextErrors.confirmPassword.dirty &&
      (field ? field === "confirmPassword" : true)
    ) {
      const confirmPasswordMessage = confirmPasswordValidatorr(
        confirmPassword,
        form
      );
      nextErrors.confirmPassword.error = !!confirmPasswordMessage;
      nextErrors.confirmPassword.message = confirmPasswordMessage;
      if (!!confirmPasswordMessage) isValid = false;
    }
    setErrors(nextErrors);

    return {
      isValid,
      errors: nextErrors,
    };
  };

  const onBlurField = (e) => {
    const field = e.target.name;
    const fieldError = errors[field];
    if (fieldError.dirty) return;

    const updatedErrors = {
      ...errors,
      [field]: {
        ...errors[field],
        dirty: true,
      },
    };

    validateForm({ form, field, errors: updatedErrors });
  };

  return {
    validateForm,
    onBlurField,
    errors,
  };
};
